<template>
  <div v-if="site" class="video-background" :class="{'blurred': blur && blurEnabled}">
    <transition name="fadeinplace">
      <slideshow v-if="showSlideshow" :srcs="stills"></slideshow>
    </transition>
    <transition name="fadeinplace">
      <video :src="src" muted loop v-show="!showSlideshow" @playing="$emit('playing')"></video>
    </transition>
  </div>
</template>

<script>
// import Config from 'src/config'
import Slideshow from './SlideshowBackground'
export default {
  name: 'cinemagraph',
  props: ['site', 'blur', 'lowRes'],
  components: {
    Slideshow
  },
  data () {
    return {
      showSlideshow: false, // window.innerWidth < Config.bkpt.mobile,
      blurEnabled: window.navigator.userAgent.indexOf('Firefox') === -1
    }
  },
  computed: {
    src () {
      if (this.site) {
        const key = window.innerWidth > 1024 || window.outerHeight > 768 ? 'site.cinemagraph' : 'site.cinemagraph--mobile'
        return this.site.data[key].value.file.url
      }
    },
    stills () {
      if (this.site) {
        const srcs = []
        const images = this.site.getGroup('site.cinemagraph--mobile-stills').toArray()
        for (var i = 0; i < images.length; i++) {
          srcs.push(images[i].getImage('images').url)
        }
        return srcs
      }
    }
  },
  methods: {
    play () {
      // Manually test autoplay following Safari recommendation
      // source: https://webkit.org/blog/7734/auto-play-policy-changes-for-macos/
      const promise = this.$el.querySelector('video').play()
      if (promise !== 'undefined') {
        promise.catch(error => {
          // Auto-play was prevented
          console.error(error)
          this.showSlideshow = true
          this.$emit('playing')
        }).then(() => {
          // Auto-play started
          this.$emit('playing')
        })
      }
    }
  },
  mounted () {
    this.$nextTick(this.play)
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';

#testAutoplayVideo{
  display:none !important;
  visibility:hidden !important;
}

.video-background{
  @include background(absolute,100%);
  background:$black;
  overflow:hidden;

  // sizing
  .no-objectfit &{
    video{
      position: absolute;
      top: 50%; 
      left: 50%;
      @include transform(translateX(-50%) translateY(-50%));
      min-width: 100%; 
      min-height: 100%; 
      width: auto; 
      height: auto;
      z-index: -1000;
    }
  }
  .objectfit &{
    video{
      @include background(absolute, 100%);
      object-fit:cover;  
    }
  }

  // transitions
  video{
    // transition delay on slide page transitions
    .slide-left-enter-active &,
    .slide-right-enter-active &{
      transition-delay: $transition-slide !important;
    }
  }

  // blur
  &.blurred {
    video, .slideshow-background{
      @include filter(blur(30px));
    }
  }  
  @media (min-width:$bkpt-mobile + 1) {
    overflow:visible;
    video, 
    .slideshow-background {
      @include transition(filter $transition-fade, -webkit-filter $transition-fade);
      .objectfit &{ // need this because it conflicts with fallback...
        transform: scale(1.07, 1.07);
        transform-origin:center;
      }
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// VideoBackground.vue?3403d05a